@if (isLoading()) {
  <div [attr.id]="id() ? id() + '-loader' : null" class="loading-overlay">
    <app-ellipsis-loading />
  </div>
}

<div [attr.id]="id() ? id() + '-header' : null" class="grid-container heading" [style.grid-template-columns]="gridTemplate()">
  @for (column of config().columns; track column.id) {
    <div
      [attr.id]="id() ? id() + '-tbl-header-' + column.id : null"
      class="row-item header-cell"
      [class.sortable]="column.sortable && !isLoading()"
      [class.disabled]="isLoading()"
      [style]="columnStyleMap()[column.id]"
      [attr.tabindex]="column.sortable && !isLoading() ? 0 : null"
      [attr.role]="column.sortable && !isLoading() ? 'button' : null"
      (click)="!isLoading() && onColumnHeaderClick(column)"
    >
      <span class="header-text">{{ column.title }}</span>

      @if (column.sortable) {
        <mat-icon class="sort-icon" [class.active]="column.sortOrder" aria-hidden="true">
          {{ getSortIcon(column) }}
        </mat-icon>
      }
    </div>
  }

  @if (hasExpandableContent()) {
    <div class="row-item header-cell expand-cell"></div>
  }
</div>

<div [attr.id]="id() ? id() + '-body' : null" class="body-container">
  @for (item of data(); track trackByItem($index, item); let i = $index) {
    <div
      [attr.id]="id() ? id() + '-tbl-row-' + getRowId(item, i) : null"
      class="grid-container"
      [style.grid-template-columns]="gridTemplate()"
      [class.row-expanded]="isRowExpanded(i)"
      [style.height]="config().rows?.height"
    >
      @for (column of config().columns; track column.id) {
        <div
          [attr.id]="id() ? id() + '-tbl-cell-' + column.id + '-' + getRowId(item, i) : null"
          class="row-item-body"
          [style]="columnStyleMap()[column.id]"
          [attr.data-label]="column.title"
        >
          @if (column.hasCustomContent && getTemplate(column.id); as template) {
            <ng-container
              [ngTemplateOutlet]="template.templateRef"
              [ngTemplateOutletContext]="{ $implicit: item, column: column, rowId: getRowId(item, i) }"
            />
          } @else {
            <span class="cell-content">{{ getCellValue(item, column) }}</span>
          }
        </div>
      }

      @if (hasExpandableContent()) {
        <div class="row-item-body expand-cell">
          <button
            [attr.id]="id() ? id() + '-tbl-btn-expand-' + getRowId(item, i) : null"
            class="expand-button"
            [class.expanded]="isRowExpanded(i)"
            (click)="toggleRowExpansion(i)"
          >
            <app-icon name="chevron_down" color="#9C9C9C" [size]="16">expand_more</app-icon>
          </button>
        </div>
      }
    </div>

    @if (hasExpandableContent() && isRowExpanded(i)) {
      <div
        [attr.id]="id() ? id() + '-tbl-row-expanded-' + getRowId(item, i) : null"
        class="expandable-row-container"
        [@detailExpand]
      >
        <ng-container
          [ngTemplateOutlet]="expandableContentTemplate!.templateRef"
          [ngTemplateOutletContext]="{ $implicit: item, expanded: true, index: i, rowId: getRowId(item, i) }"
        />
      </div>
    }
  } @empty {
    @if (!isLoading()) {
      <div class="no-registers-found">
        @if (noDataContentTemplate) {
          <ng-container [ngTemplateOutlet]="noDataContentTemplate" />
        } @else {
          <span [attr.id]="id() ? id() + '-empty-msg' : null">{{ noDataMessage() }}</span>
        }
      </div>
    }
  }
</div>

@if (showPagination() && data().length) {
  <app-paginator
    [id]="id() ? id() + '-paginator' : undefined"
    [page]="page()"
    [pageSize]="pageSize()"
    [totalRegisters]="totalRegisters()"
    [disabled]="isLoading()"
    (changePage)="onPageChange($event)"
  />
}
